import { useState } from 'react';
import invoiceService from '../services/invoiceService';

/**
 * Hook personalizado para manejar operaciones de facturación
 */
const useInvoice = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Generar factura electrónica
   */
  const generateInvoice = async (saleId, invoiceData) => {
    setLoading(true);
    setError(null);
    try {
      const result = await invoiceService.generateForSale(saleId, invoiceData);
      setLoading(false);
      if (!result.success) {
        setError(result.message);
      }
      return result;
    } catch (err) {
      const errorMsg = err.response?.data?.message || 'Error al generar factura';
      setError(errorMsg);
      setLoading(false);
      throw err;
    }
  };

  /**
   * Obtener factura de una venta
   */
  const getInvoiceBySale = async (saleId) => {
    setLoading(true);
    setError(null);
    try {
      const result = await invoiceService.getBySale(saleId);
      setLoading(false);
      if (!result.success) {
        setError(result.message);
      }
      return result;
    } catch (err) {
      const errorMsg = err.response?.data?.message || 'Error al obtener factura';
      setError(errorMsg);
      setLoading(false);
      return null;
    }
  };

  /**
   * Listar facturas con filtros
   */
  const listInvoices = async (params) => {
    setLoading(true);
    setError(null);
    try {
      const result = await invoiceService.list(params);
      setLoading(false);
      if (!result.success) {
        setError(result.message);
      }
      return result;
    } catch (err) {
      const errorMsg = err.response?.data?.message || 'Error al listar facturas';
      setError(errorMsg);
      setLoading(false);
      throw err;
    }
  };

  /**
   * Verificar estado de ARCA
   */
  const checkStatus = async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await invoiceService.getStatus();
      setLoading(false);
      if (!result.success) {
        setError(result.message);
      }
      return result;
    } catch (err) {
      const errorMsg = err.response?.data?.message || 'Error al verificar estado';
      setError(errorMsg);
      setLoading(false);
      return { success: false, data: { configured: false } };
    }
  };

  return {
    loading,
    error,
    generateInvoice,
    getInvoiceBySale,
    listInvoices,
    checkStatus
  };
};

export default useInvoice;

